import { MessageTransactionMessagePreference } from '@quorum/models/xs-resource';
import { MessageTransactionMessagePreferenceQueryParameters} from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export enum MessageTransactionMessagePreferenceEntityActionTypes {
  // eslint-disable-next-line max-len
  GetMessageTransactionMessagePreferencesFromServer = '[Fixed Operations] Get Message Transaction Message Preference From Server',
  // eslint-disable-next-line max-len
  GetMessageTransactionMessagePreferencesFromServerError = '[Fixed Operations] Get Message Transaction Message Preference From Server Error',
  // eslint-disable-next-line max-len
  GetMessageTransactionMessagePreferencesFromServerSuccess = '[Fixed Operations] Get Message Transaction Message Preference From Server Success',
  // eslint-disable-next-line max-len
  UpdateMessageTransactionMessagePreferenceOnServer = '[Fixed Operations] Update Message Transaction Message Preference On Server',
  // eslint-disable-next-line max-len
  UpdateMessageTransactionMessagePreferenceOnServerError = '[Fixed Operations] Update Message Transaction Message Preference On Server Error',
  // eslint-disable-next-line max-len
  UpdateMessageTransactionMessagePreferenceOnServerSuccess = '[Fixed Operations] Update Message Transaction Message Preference On Server Success',
  // eslint-disable-next-line max-len
  CreateMessageTransactionMessagePreferenceOnServer = '[Fixed Operations] Create Message Transaction Message Preference On Server',
  // eslint-disable-next-line max-len
  CreateMessageTransactionMessagePreferenceOnServerError = '[Fixed Operations] Create Message Transaction Message Preference On Server Error',
  // eslint-disable-next-line max-len
  CreateMessageTransactionMessagePreferenceOnServerSuccess = '[Fixed Operations] Create Message Transaction Message Preference On Server Success',
  // eslint-disable-next-line max-len
  DeleteMessageTransactionMessagePreferenceFromServer = '[Fixed Operations] Delete Message Transaction Message Preference From Server',
  // eslint-disable-next-line max-len
  DeleteMessageTransactionMessagePreferenceFromServerError = '[Fixed Operations] Delete Message Transaction Message Preference From Server Error',
  // eslint-disable-next-line max-len
  DeleteMessageTransactionMessagePreferenceFromServerSuccess = '[Fixed Operations] Delete Message Transaction Message Preference From Server Success'
}

export class GetMessageTransactionMessagePreferencesFromServer implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.GetMessageTransactionMessagePreferencesFromServer;
  constructor(public payload: { params: MessageTransactionMessagePreferenceQueryParameters; returnAction: any }) {}
}

export class GetMessageTransactionMessagePreferencesFromServerError implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.GetMessageTransactionMessagePreferencesFromServerError;
  constructor(public payload: any) {}
}

export class GetMessageTransactionMessagePreferencesFromServerSuccess implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.GetMessageTransactionMessagePreferencesFromServerSuccess;
  constructor(public payload: MessageTransactionMessagePreference) {}
}

export class UpdateMessageTransactionMessagePreferenceOnServer implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.UpdateMessageTransactionMessagePreferenceOnServer;
  constructor(
    public payload: {
      messageTransactionMessagePreference: MessageTransactionMessagePreference;
      messageTransactionMessagePreferenceQueryParams: MessageTransactionMessagePreferenceQueryParameters;
    }
  ) {}
}
export class UpdateMessageTransactionMessagePreferenceOnServerError implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.UpdateMessageTransactionMessagePreferenceOnServerError;
  constructor(public payload: any) {}
}
export class UpdateMessageTransactionMessagePreferenceOnServerSuccess implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.UpdateMessageTransactionMessagePreferenceOnServerSuccess;
  constructor(public payload: MessageTransactionMessagePreference) {}
}

export class CreateMessageTransactionMessagePreferenceOnServer implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.CreateMessageTransactionMessagePreferenceOnServer;
  constructor(
    public payload: {
      messageTransactionMessagePreference: MessageTransactionMessagePreference;
    }
  ) {}
}
export class CreateMessageTransactionMessagePreferenceOnServerError implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.CreateMessageTransactionMessagePreferenceOnServerError;
  constructor(public payload: any) {}
}
export class CreateMessageTransactionMessagePreferenceOnServerSuccess implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.CreateMessageTransactionMessagePreferenceOnServerSuccess;
  constructor(public payload: MessageTransactionMessagePreference) {}
}

export class DeleteMessageTransactionMessagePreferenceFromServer implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.DeleteMessageTransactionMessagePreferenceFromServer;
  constructor(public payload: { messageTransactionMessagePreference: MessageTransactionMessagePreference }) {}
}
export class DeleteMessageTransactionMessagePreferenceFromServerError implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.DeleteMessageTransactionMessagePreferenceFromServerError;
  constructor(public payload: any) {}
}
export class DeleteMessageTransactionMessagePreferenceFromServerSuccess implements Action {
  readonly type =
    MessageTransactionMessagePreferenceEntityActionTypes.DeleteMessageTransactionMessagePreferenceFromServerSuccess;
  constructor(public payload: { messageTransactionMessagePreference: MessageTransactionMessagePreference }) {}
}
//#endregion

export type MessageTransactionMessagePreferencesEntityAction =
  | GetMessageTransactionMessagePreferencesFromServer
  | GetMessageTransactionMessagePreferencesFromServerError
  | GetMessageTransactionMessagePreferencesFromServerSuccess
  | UpdateMessageTransactionMessagePreferenceOnServer
  | UpdateMessageTransactionMessagePreferenceOnServerError
  | UpdateMessageTransactionMessagePreferenceOnServerSuccess
  | CreateMessageTransactionMessagePreferenceOnServer
  | CreateMessageTransactionMessagePreferenceOnServerError
  | CreateMessageTransactionMessagePreferenceOnServerSuccess
  | DeleteMessageTransactionMessagePreferenceFromServer
  | DeleteMessageTransactionMessagePreferenceFromServerError
  | DeleteMessageTransactionMessagePreferenceFromServerSuccess;

export const fromMessageTransactionMessagePreferencesEntityActions = {
  GetMessageTransactionMessagePreferencesFromServer,
  GetMessageTransactionMessagePreferencesFromServerError,
  GetMessageTransactionMessagePreferencesFromServerSuccess,
  UpdateMessageTransactionMessagePreferenceOnServer,
  UpdateMessageTransactionMessagePreferenceOnServerError,
  UpdateMessageTransactionMessagePreferenceOnServerSuccess,
  CreateMessageTransactionMessagePreferenceOnServer,
  CreateMessageTransactionMessagePreferenceOnServerError,
  CreateMessageTransactionMessagePreferenceOnServerSuccess,
  DeleteMessageTransactionMessagePreferenceFromServer,
  DeleteMessageTransactionMessagePreferenceFromServerError,
  DeleteMessageTransactionMessagePreferenceFromServerSuccess
};
